import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { ChevronLeft } from '../../icons/arrows/ChevronLeft';
import { ChevronRight } from '../../icons/arrows/ChevronRight';
import styles from './Carousel.module.scss';
export const CarouselArrowButton = (param)=>{
    let { direction, visible, ariaLabel, testId, onClick } = param;
    const directionClass = direction === 'left' ? styles.arrowButtonLeft : styles.arrowButtonRight;
    const Chevron = direction === 'left' ? ChevronLeft : ChevronRight;
    return /*#__PURE__*/ _jsx("button", {
        type: "button",
        className: cn(styles.arrowButton, directionClass, {
            [styles.arrowButtonVisible]: visible
        }),
        "data-testid": testId,
        "aria-label": ariaLabel,
        onClick: onClick,
        children: /*#__PURE__*/ _jsx(Chevron, {
            size: 20
        })
    });
};
